import React, { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./ReportSubmission.scss";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { REPORT_SUBMISSION_DATA } from "../../../../constants/ReportedDataMenus_constants";
import { emitToasterMsg } from "../../../../services/toasterUtility";
import { Box, IconButton, MenuItem, Select, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { accessAPIForResponse } from "../../../../services/api-services/api-implementations";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { AbsDropDown, Button, COLORS, Icon, ICONS, Label, Modal, RadioInput, AbsCheckBox } from "abs-ui-components";
import { CheckChildReportPositionWarning, CreateChildReports, DeleteChildReports, ReportTimeSlots, getReportSummission } from "../../../../services/ChildReportService";
import AbsModal from "../../../../common/absModal/AbsModal";
import { DCSEventTypes, EUMRVEventTypes, FEUMRVEventTypes, UKMRVEventTypes, UKETSEventTypes } from "../../../../constants/ReportSubmissionConstants";
import { getFormattedDate } from "../../../../services/DateFormatUtility";
import { CANCEL, DELETE, DELETE_CONFIRMATION_TEXT_FOR_SINGLE_RECORD } from "../../../../constants/CommonConstants";
import { reportsActions } from "../../../../store/reports/reports.slice";
import { ClaimsContext } from "../../../../services/ClaimsService";
import { ClaimType } from "../../../../constants/claims";
import { FeatureType } from "../../../../constants/FeatureToggles";
import { set } from "lodash";
import axiosHttp from "../../../../services/interceptor";
import webhookQueueService from "../../../../services/WebhookQueueService";

dayjs.extend(utc);
dayjs.extend(customParseFormat);
const ReportSubmission = () => {
	// Error states for required fields
	const [startDateError, setStartDateError] = useState("");
	const [endDateError, setEndDateError] = useState("");
	const { userHasClaim } = useContext(ClaimsContext);
	const navigate = useNavigate();
	const currentYear = localStorage.getItem("selectedYear") || dayjs().year();
	let startDateForFullYear = dayjs(`01-01-${currentYear}`).format("MM-DD-YYYY");
	let endDateForFullYear = dayjs(`12-31-${currentYear}`).format("MM-DD-YYYY");
	const reportDetails = useSelector((state) => state?.reports?.selectedReportDetails);
	const [vesselMrvTypeName, setVesselMrvTypeName] = useState("");
	const reportMrvVesselTypeName =
		reportDetails?.MrvVesselTypeName ||
		reportDetails?.VesselMst?.MrvVesselTypeName ||
		reportDetails?.VesselMst?.MrvVesselTypeMst?.Value ||
		reportDetails?.VesselMst?.MrvVesselType?.Value ||
		reportDetails?.VesselMst?.MrvVesselType?.Name ||
		reportDetails?.VesselMst?.OtherMrvVesselTypeName;
	const mrvVesselTypeName = vesselMrvTypeName || reportMrvVesselTypeName;
	const isOffshoreShip = typeof mrvVesselTypeName === "string" && mrvVesselTypeName.trim().toLowerCase() === "offshore ship";
	const getVesselTypeName = async () => {
		if (!reportDetails?.VesselMstId) return "";

		const response = await axiosHttp.get(
			`api/MyFleet/GetVesselById?vesselMstId=${reportDetails.VesselMstId}`
		);
		const vesselData = response?.data?.Data;
		return vesselData?.MrvVesselTypeMst?.Value || vesselData?.OtherMrvVesselTypeName || "";
	};
	const isRefetchReportDetails = useSelector((state) => state?.reports?.isRefetch);
	const dispatch = useDispatch();
	const user = useSelector((state) => state.userInfo.userData);
	const [ReportData, setReportData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [regulation, setRegulation] = useState([]);
	const [eventTypeOptions, setEventTypeOptions] = useState();
	const [selectedEventType, setSelectedEVentType] = useState("full_year");
	const [allowedDateAndTime, setAllowedDateAndTime] = useState();
	const [selectedStartDate, setSelectedStartDate] = useState(null);
	const [startDateTimeSlots, setStartDateTimeSlots] = useState([]);
	const [selectedEndDate, setSelectedEndDate] = useState(null);
	const [endDateTimeSlots, setEndDateTimeSlots] = useState([]);
	const [selectedStartTime, setSelectedStartTime] = useState("");
	const [selectedEndTime, setSelectedEndTime] = useState("");
	const [showStartTimesslot, setShowStartTimeslot] = useState(false);
	const [showEndTimesslot, setshowEndTimesslot] = useState(false);
	const [formatAllowDateandTime, setFormatAllowDateandTime] = useState([]);
	const [dateValidation, setdateValidation] = useState(true);
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [allRegulationEVentOptions, setAllRegulationEVentOptions] = useState([]);
	const [confirmDelete, setConfirmDelete] = useState(false);
	const [defaultFirstEnableDate, setDefaultFirstEnableDate] = useState();
	const [selectedChildReport, setSelectedChildReport] = useState();
	const [isSubmit, setIsSubmit] = useState(false);
	const [isAnyMisStatementErrors, setIsAnyMisStatementErrors] = useState(true);
	const [isMisStatementCalled, setIsMisStatementCalled] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const [showPositionWarning, setShowPositionWarning] = useState(false);
	const activeRegulationRef = useRef("");
	const activeEventTypeRef = useRef("full_year");
	const { userFeaturesAreLoaded, userHasFeature } = useContext(ClaimsContext);
	const reportYear = Number(currentYear);
	const requiredEndDate = "04-02-2026";

	// UKETS (Partial - Change of Company) RY2026: Start Date must not be before this date
	const UKETS_MIN_START_DATE = "2026-07-01";
	//ukets start/end date validation logic
	const isRY2026 = reportYear === 2026;
	const isFullYear = selectedEventType === "full_year";
	const isPartialChangeOfCompany = selectedEventType === "partial_change_of_company";
	// UKETS + Partial Change of Company + RY2026: user can pick Start Date, but not before 01-Jul-2026
	const isUKETSMinStartDate = isPartialChangeOfCompany && regulation === "UKETS" && isRY2026;
	const startDateOptions = isUKETSMinStartDate
		? allowedDateAndTime?.filter((item) => !dayjs(item.dateStamp).isBefore(dayjs(UKETS_MIN_START_DATE), "day"))
		: allowedDateAndTime;
	const endDateOptions = isUKETSMinStartDate
		? allowedDateAndTime?.filter((item) => !dayjs(item.dateStamp).isBefore(dayjs(UKETS_MIN_START_DATE), "day"))
		: allowedDateAndTime;
	const regulationOptions = [
		{ label: "DCS", value: "DCS" },
		{ label: "EU MRV", value: "EUMRV" },
		{ label: "UK MRV", value: "UKMRV" },
		{ label: "FEU", value: "FEU" },
		...(Number(reportYear) >= 2026
        ? [{ label: "UK ETS", value: "UKETS" }]
        : []),
	];

	useEffect(() => {
		setAllRegulationEVentOptions([...DCSEventTypes, ...EUMRVEventTypes, ...UKMRVEventTypes, ...FEUMRVEventTypes, ...UKETSEventTypes]);

		onChangeRegulation(["DCS"]);

		if (eventTypeOptions?.length) {
			setSelectedEVentType(eventTypeOptions[0]);
		}
	}, []);

	useEffect(() => {
		let isMounted = true;

		const fetchVesselType = async () => {
			if (!reportDetails?.VesselMstId) {
				setVesselMrvTypeName("");
				return;
			}

			try {
				const fetchedVesselTypeName = await getVesselTypeName();

				if (isMounted) {
					setVesselMrvTypeName(fetchedVesselTypeName);
				}
			} catch (error) {
				if (isMounted) {
					setVesselMrvTypeName("");
				}
				console.error(error);
			}
		};

		fetchVesselType();

		return () => {
			isMounted = false;
		};
	}, [reportDetails?.VesselMstId]);

	useEffect(() => {
		let formatAllowDate =
			allowedDateAndTime?.map((item) => ({
				value: item.dateStamp,
				label: dayjs(item.dateStamp).format("MM/DD/YYYY"),
			})) || [];

		setFormatAllowDateandTime(formatAllowDate);

		if (allowedDateAndTime?.length) {
			const firstEnabledDate = dayjs(allowedDateAndTime[0].dateStamp);
			setDefaultFirstEnableDate(firstEnabledDate?.$d);
			setSelectedStartDate(firstEnabledDate?.$d);
			setSelectedEndDate(firstEnabledDate?.$d);
			handleChangeDate(firstEnabledDate, "startDate");
			handleChangeDate(firstEnabledDate, "endDate");
		}
	}, [allowedDateAndTime]);

	const getEventName = (eventTypeValue) => {
	const eventName = allRegulationEVentOptions.find(
		(eventType) => eventType.value === eventTypeValue
	);
	return eventName?.label || eventTypeValue;
};

	useEffect(() => {
		fetchGetReportSubmissionData();
		getIsAnyMisStatementError();
		reportTimeSlots();
	}, [reportDetails.ReportMstId]);

	const handleReportClick = (row) => {
		navigate(`/reports/${row.original.reportMstId}`);
		window.location.reload();
	};

	const reportTimeSlots = async () => {
		try {
			const responseData = await ReportTimeSlots(reportDetails.ReportMstId);

			if (responseData) {
				setAllowedDateAndTime(responseData.data.data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const fetchGetReportSubmissionData = async () => {
		setLoading(true);
		try {
			const reportSubmission = await getReportSummission(reportDetails.ReportMstId);
			if (reportSubmission?.data?.length > 0) {
				let childReports = reportSubmission?.data[0].childReports;
				setReportData(childReports);
			}
			setLoading(false);
		} catch (error) {
			console.error(error);
		}
	};

	const handleDeleteConfirm = (row, isConfirm) => {
		setConfirmDelete(isConfirm);
		setSelectedChildReport(row);
	};

	const handleDelete = async () => {
		setLoading(true);
		try {
			const responseData = await DeleteChildReports(selectedChildReport?.original?.reportMstId);
			if (responseData?.data?.isSuccess) {
				fetchGetReportSubmissionData();
				getIsAnyMisStatementError();
				setLoading(false);
				emitToasterMsg("success", "Delete", "Report Deleted Successfully");
				dispatch(
					reportsActions.setRefetchReportDetails({
						isRefetch: !isRefetchReportDetails,
					})
				);
			} else {
			}
		} catch (error) {
			console.error(error);
			setLoading(false);
		}
		setConfirmDelete(false);
	};

	const submitToABS = async (reportMstId) => {
		setLoading(true);

		try {
			const response = await accessAPIForResponse("submitToABS", null, [reportMstId]);

			if (response && response?.isSuccess) {
				const data = response?.data;
				const errors = [data?.startOfYearError, data?.endOfYearError].filter(Boolean);

				// MIS validation failed: one red toaster with all messages
				if (errors.length > 0) {
					emitToasterMsg(
						"error",
						<div>
							{errors.map((msg, i) => (
								<div key={i}>{msg}</div>
							))}
						</div>
					);
				}
				// Submitted successfully
				if (data) {
					fetchGetReportSubmissionData();
					getIsAnyMisStatementError();
					emitToasterMsg("success", "Submitted to ABS successfully");
					dispatch(
						reportsActions.setRefetchReportDetails({
							isRefetch: !isRefetchReportDetails,
						})
					);
				}
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false); 
		}
	};
	const getIsAnyMisStatementError = async () => {
		await accessAPIForResponse("GetIsAnyMisStatementErrors", null, [reportDetails.ReportMstId])
			.then((response) => {
				if (response) {
					setIsAnyMisStatementErrors(response.IsAnyMisStatementError);
					setIsMisStatementCalled(response.IsMisStatementCalled);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const reportSubmissionColumns = [
		{
			header: "",
			accessorKey: "delete",
			enableEditing: false,

			size: 100,
			Cell: ({ row }) => {
				const reportStatus = row.original.reportStatus;
				const showDeleteBtn =
					reportStatus.toLowerCase() === REPORT_SUBMISSION_DATA.SUBMIT_ABS_REPORT_STATUS.toLowerCase()
						? userHasClaim(ClaimType.DELETE_REPORT)
						: userHasClaim(ClaimType.DELETE_ANY_REPORT);
				if (showDeleteBtn) {
					return (
						<Box sx={{ display: "flex", gap: "1rem" }}>
							<Tooltip title="Delete">
								<IconButton color="error" onClick={() => handleDeleteConfirm(row, true)}>
									<DeleteIcon />
								</IconButton>
							</Tooltip>
						</Box>
					);
				}
			},
		},
		{
			header: "Report Name",
			accessorKey: "reportName",
			size: 250,
			Cell: ({ row }) => {
				return (
					<a href={`${window.location.origin}/reports/${row.original.reportMstId}`}>
						<div
							className="report-name"
							onClick={() => {
								handleReportClick(row);
							}}
						>
							{row.original.reportName}
						</div>
					</a>
				);
			},
		},
		{
			header: "Regulation",
			accessorKey: "regulations",
		},
		{
			header: "Report Status",
			accessorKey: "reportStatus",
		},
		{
			header: "Report Type",
			accessorKey: "eventType",
			Cell: ({ row }) => {
				return <div>{getEventName(row.original.eventType)}</div>;
			},
		},
		{
			header: "Start Date",
			accessorKey: "reportStartDate",
			Cell: ({ row }) => {
				return <div>{dayjs(row.original.reportStartDate).format("DD-MMM--YYYY HH:mm:ss")}</div>;
			},
		},
		{
			header: "End Date",
			accessorKey: "reportEndDate",
			Cell: ({ row }) => {
				return <div>{dayjs(row.original.reportEndDate).format("DD-MMM-YYYY HH:mm:ss")}</div>;
			},
		},

		{
			header: "Action",
			accessorKey: "actions",
			enableEditing: true,
			Cell: ({ row }) => {
				const reportStatus = row.original.reportStatus;

				let buttonText;
				let backgroundColor = COLORS.GREEN.DARK;
				let isDisabled = false;
				if (reportStatus.toLowerCase() === REPORT_SUBMISSION_DATA.SUBMIT_ABS_REPORT_STATUS.toLowerCase()) {
					buttonText = REPORT_SUBMISSION_DATA.SUBMIT_ABS;
					if (!isMisStatementCalled || (isMisStatementCalled && isAnyMisStatementErrors)) {
						backgroundColor = COLORS.GREY60;
						isDisabled = true;
					} else if (isMisStatementCalled && !isAnyMisStatementErrors) {
						backgroundColor = COLORS.RED10;
						isDisabled = false;
					}
				} else if (
					reportStatus.toLowerCase() === REPORT_SUBMISSION_DATA.SUBMITTED_ABS_REPORT_STATUS.toLowerCase() ||
					reportStatus.toLowerCase() === REPORT_SUBMISSION_DATA.VERIFICATION_PROGRESS_REPORT_STATUS.toLowerCase() ||
					reportStatus.toLowerCase() === REPORT_SUBMISSION_DATA.VERIFICATION_COMPLETE_REPORT_STATUS.toLowerCase() ||
					reportStatus.toLowerCase() === REPORT_SUBMISSION_DATA.SUPPORTING_DOCS_NEEDED.toLowerCase()
				) {
					buttonText = REPORT_SUBMISSION_DATA.SUBMITTED_ABS;
					backgroundColor = COLORS.GREY60;
					isDisabled = true;
				}
				return (
					<div className="button-status d-flex">
						<Button
							className="p-1"
							primaryBackgroundColor={backgroundColor}
							primaryColor={backgroundColor}
							radius={"2px"}
							disabled={isDisabled}
							onClick={() => submitToABS(row.original.reportMstId)}
						>
							{buttonText}
						</Button>
					</div>
				);
			},
		},
	];

	const reportSubmissionTable = useMaterialReactTable({
		columns: reportSubmissionColumns,
		data: ReportData,
		enableStickyHeader: true,
		enablePagination: false,
		enableSorting: false,
		enableColumnFilters: false,
		enableColumnActions: false,
		initialState: {
			showColumnFilters: true,
		},
		state: {
			isLoading: loading,
		},
		muiTableHeadCellProps: ({ column }) => ({
			id: `${column.id}`,
			sx: {
				color: "rgb(255 255 255)",
				"& .MuiButtonBase-root": {
					color: "white !important",
					"& .MuiTableSortLabel-icon": {
						color: "white !important",
					},
				},
			},
		}),
		muiFilterTextFieldProps: {
			sx: {
				"& .MuiInput-root": {
					color: "white !important",
				},
				"& .MuiButtonBase-root": {
					color: "white !important",
				},
				"& .MuiInputBase-root::after": {
					transform: "none",
					borderBottom: "2px solid white",
				},
			},
		},
		muiColumnActionsButtonProps: {
			sx: {
				color: "white",
			},
		},
		muiTableHeadRowProps: {
			sx: {
				backgroundColor: "#042a4c !important",
				"& .MuiTableCell-head::before": {
					backgroundColor: "#042a4c !important",
				},
				"& .MuiDivider-root": {
					backgroundColor: "white",
				},
			},
		},
		muiTablePaperProps: {
			sx: {
				boxShadow: "0 0 8px 2px rgba(0, 0, 0, 0.1)",
			},
		},
	});

	const openCreateReportModal = () => {
		setOpenModal(!openModal);
		if (openModal) {
			onChangeRegulation(["DCS"]);
			setShowStartTimeslot(false);
			setshowEndTimesslot(false);
			setSelectedStartTime("");
			setSelectedEndTime("");
			setSelectedEVentType("full_year");
			setShowPositionWarning(false);
			setStartDateError("");
			setEndDateError("");
			setIsSubmit(false);
			setStartDateError("");
			setEndDateError("");
			if (allowedDateAndTime?.length) {
				const firstEnabledDate = dayjs(allowedDateAndTime[0].dateStamp);
				setSelectedStartDate(firstEnabledDate?.$d);
				setSelectedEndDate(firstEnabledDate?.$d);
			}
			setRegulation(["DCS"]);
			setEventTypeOptions(DCSEventTypes);
		}
	};


	const onChangeRegulation = (selectedRegulations) => {
		activeRegulationRef.current = selectedRegulations.includes("EUMRV")? "EUMRV" : selectedRegulations.includes("FEU") ? "FEU" : selectedRegulations[selectedRegulations.length - 1] || "";
		setShowStartTimeslot(false);
		setshowEndTimesslot(false);
		setSelectedStartDate(null);
		setSelectedEndDate(null);
		setSelectedStartTime("");
		setSelectedEndTime("");
		setStartDateTimeSlots([]);
		setEndDateTimeSlots([]);

		const regulationEventTypes = {
			DCS: DCSEventTypes,
			EUMRV: EUMRVEventTypes,
			UKMRV: UKMRVEventTypes,
			FEU: FEUMRVEventTypes,
			UKETS: UKETSEventTypes,
		};

		// Handle empty selection
		if (!selectedRegulations?.length) {
			setEventTypeOptions([]);
			setRegulation([]);
			handleChangeEventType("");
			return;
		}

		// Get event types for each selected regulation,
		// applying the existing year-specific conditions.
		const eventTypesByRegulation = selectedRegulations.map(
			(selectedRegulation) => {
				let eventTypes =
					regulationEventTypes[selectedRegulation] ?? [];

				if (selectedRegulation === "UKMRV") {
					eventTypes = eventTypes.filter((item) => {
						if (item.value === "full_year") return true;

						if (
							item.value ===
							"partial_from_1_jan_2026_to_2_apr_2026"
						) {
							return Number(reportYear) === 2026;
						}

						return false;
					});
				}

				if (selectedRegulation === "UKETS") {
					eventTypes = eventTypes.filter((item) => {
						if (
							item.value === "partial_change_of_company"
						) {
							return true;
						}

						if (
							item.value === "partial_reporting_period_2026"
						) {
							return Number(reportYear) === 2026;
						}

						if (item.value === "full_year") {
							return Number(reportYear) >= 2026;
						}

						return false;
					});
				}

				return eventTypes;
			}
		);
		// Keep only event types available in EVERY selected regulation.
		const commonEventTypes = eventTypesByRegulation[0].filter(
			(eventType) =>
				eventTypesByRegulation.every((eventTypes) =>
					eventTypes.some(
						(item) => item.value === eventType.value
					)
				)
		);

		setEventTypeOptions(commonEventTypes);
		setRegulation(selectedRegulations);

		// Keep the previously selected event type if it remains valid;
		// otherwise, select the first common event type.
		handleChangeEventType(commonEventTypes[0] ?? "", selectedRegulations);
	};

	const checkPositionWarning = async (start, end, selectedRegulation = regulation, selectedEvent = activeEventTypeRef.current) => {
		if (!start || !end || (!selectedRegulation.includes("EUMRV") && !selectedRegulation.includes("FEU"))) return;

		const parsedStart = dayjs(start, ["MM-DD-YYYY HH:mm:ss", "MM-DD-YYYY H:mm:ss"], true);
		const parsedEnd = dayjs(end, ["MM-DD-YYYY HH:mm:ss", "MM-DD-YYYY H:mm:ss"], true);
		const response = await CheckChildReportPositionWarning({
			parentReportMstId: +reportDetails.ReportMstId,
			reportStartDate: (parsedStart.isValid() ? parsedStart : dayjs(start)).format("YYYY-MM-DDTHH:mm:ss"),
			reportEndDate: (parsedEnd.isValid() ? parsedEnd : dayjs(end)).format("YYYY-MM-DDTHH:mm:ss"),
			regulations: selectedRegulation?.includes("EUMRV") ? "EUMRV" : selectedRegulation?.includes("FEU") ? "FEU" : "",
		});
		if ( selectedRegulation.includes(activeRegulationRef.current) && activeEventTypeRef.current === selectedEvent) {
			setShowPositionWarning((response?.showWarning ?? response?.data?.showWarning) === true);
		}
	};

	const handleChangeEventType = (eventType, activeRegulation = regulation) => {
		if (!eventType?.value) {
			activeEventTypeRef.current = "";
			setSelectedEVentType("");
			setShowPositionWarning(false);
			return;
		}
		const { value } = eventType;
		activeEventTypeRef.current = value;
		setSelectedEVentType(value);
		if ((value !== "full_year" && value !== "partial_change_of_company") || (!activeRegulation.includes("EUMRV") && !activeRegulation.includes("FEU"))) {
			setShowPositionWarning(false);
		}
		if (value !== "full_year") {
			setSelectedStartDate(null);
			setSelectedEndDate(null);
			setSelectedStartTime("");
			setSelectedEndTime("");
			setStartDateTimeSlots([]);
			setEndDateTimeSlots([]);
			return;
		}
		if (value === "full_year" && (activeRegulation.includes("EUMRV") || activeRegulation.includes("FEU"))) {
			checkPositionWarning(`${startDateForFullYear} 12:00:00`, `${endDateForFullYear} 11:59:00`, activeRegulation);
		} else if (
			value !== "full_year" &&
			selectedStartDate &&
			selectedEndDate &&
			selectedStartTime &&
			selectedEndTime &&
			(activeRegulation.includes("EUMRV") || activeRegulation.includes("FEU"))
		) {
			checkPositionWarning(
				`${dayjs(selectedStartDate).format("MM-DD-YYYY")} ${selectedStartTime}`,
				`${dayjs(selectedEndDate).format("MM-DD-YYYY")} ${selectedEndTime}`,
				activeRegulation
			);
		}
	};

	// selecting the date
	const handleChangeDate = (date, dateType) => {
		if (dateType === "startDate") {
			setStartDate(date);
			if (new Date(date) <= new Date(endDate)) {
				setdateValidation(true);
			}
			setStartDateError("");
		} else if (dateType === "endDate") {
			setEndDate(date);
			if (new Date(startDate) <= new Date(date)) {
				setdateValidation(true);
			}
			setEndDateError("");
		}

		if (dateType === "startDate") {
			setSelectedStartTime("");
			setShowStartTimeslot(true);
		} else if (dateType === "endDate") {
			setSelectedEndTime("");
			setshowEndTimesslot(true);
		}

		if (date !== undefined) {
			dateType === "startDate" ? setSelectedStartDate(null) : setSelectedEndDate(null);
			if (date) {
				let selectedDate = JSON.stringify(date);
				dateType === "startDate" ? setSelectedStartDate(selectedDate) : setSelectedEndDate(selectedDate);
				let allowedTimeSlots = allowedDateAndTime.find((allowedDateWithTime) => {
					return allowedDateWithTime?.dateStamp === getFormattedDate(selectedDate);
				})?.timeStamps;

				// set the time slotss for selected start date
				if (dateType === "startDate") {
					setStartDateTimeSlots(allowedTimeSlots);
				} else {
					// set the time slots for selected end date
					setEndDateTimeSlots(allowedTimeSlots);
				}
			}
		}
	};

	// change time slot
	const handleChangeTime = (event, dateType) => {
		let time = event?.target?.value;
		if (dateType === "startTime") {
			setSelectedStartTime(time);
			if (selectedStartDate && selectedEndDate && selectedEndTime && (regulation.includes("EUMRV") || regulation.includes("FEU"))) {
				checkPositionWarning(`${dayjs(selectedStartDate).format("MM-DD-YYYY")} ${time}`, `${dayjs(selectedEndDate).format("MM-DD-YYYY")} ${selectedEndTime}`, regulation);
			}
		} else {
			setSelectedEndTime(time);
			if (selectedStartDate && selectedEndDate && selectedStartTime && (regulation.includes("EUMRV") || regulation.includes("FEU"))) {
				checkPositionWarning(`${dayjs(selectedStartDate).format("MM-DD-YYYY")} ${selectedStartTime}`, `${dayjs(selectedEndDate).format("MM-DD-YYYY")} ${time}`, regulation);
			}
		}
	};

	//check time validation and submit the create child report API
	const normalizeDate = (date) => {
		return dayjs(date).format("MM/DD/YYYY");
	};
	const isDateAvailable = (targetDate) => {
		const normalizedTarget = normalizeDate(targetDate);
		return allowedDateAndTime?.some((item) => {
			const itemDate = normalizeDate(item.dateStamp);
			return itemDate === normalizedTarget;
		});
	};

	// selectedStartDate / selectedEndDate can be a Date, a JSON string or a plain string
	const parseSelectedDate = (value) => {
		if (value instanceof Date) return dayjs(value);
		try {
			return dayjs(JSON.parse(value));
		} catch (e) {
			return dayjs(value);
		}
	};

	const enqueueChildReportCreation = async (payloadData) => {
		const isWebhookPanelVisible = userFeaturesAreLoaded && userHasFeature(FeatureType.ViewWebhookPanel);

		try {
			webhookQueueService.enqueue(
			() =>
				axiosHttp({
					url: `api/Report/CreateMultipleChildReports`,
					method: "POST",
					data: payloadData
				}),
			{
				label: "Child Report(s) Creation",
				description: "Creating Child Report(s)",
				silent: !isWebhookPanelVisible,
				onComplete: async (result) => {
					try {
						fetchGetReportSubmissionData();
					} catch (error) {
						console.error(error);
					}
				},
				onError: (error) => {
					console.error(error);
				},
			}
		);
	} catch (error) {
		console.error(error);
	}
	};

	useEffect(() => {
		// Re-attach callbacks for any in-progress MIS validation after page refresh
		const state = webhookQueueService.getState();
		const inProgressOp = state.queue.find(
			(op) => op.label === "Child Report(s) Creation" && op.status === "processing"
		);
		if (inProgressOp?.webhookId) {
			webhookQueueService.reattachCallbacks(inProgressOp.webhookId, {
				onComplete: async (result) => {
					try {
						fetchGetReportSubmissionData();
					} catch (error) {
						console.error(error);
					}
				},
				onError: (error) => {
					console.error(error);
				},
			});
		}
	}, []);

	const submitCreateChildReport = async () => {
		let isCurrentVesselOffshore = isOffshoreShip;
		if (regulation === "FEU" && !mrvVesselTypeName && reportDetails?.VesselMstId) {
			try {
				const fetchedVesselTypeName = await getVesselTypeName();
				setVesselMrvTypeName(fetchedVesselTypeName);
				isCurrentVesselOffshore = fetchedVesselTypeName.trim().toLowerCase() === "offshore ship";
			} catch (error) {
				console.error(error);
			}
		}
		if (regulation === "FEU" && isCurrentVesselOffshore) {
			emitToasterMsg("error", "Not Applicable", "FEU Maritime Regulation is not applicable to Offshore ships.");
			return;
		}
		setStartDateError("");
		setEndDateError("");

		// UK MRV PARTIAL VALIDATION
		const isUKMRVPartial = selectedEventType === "partial_from_1_jan_2026_to_2_apr_2026";
		if (isUKMRVPartial) {
			const isAvailable = isDateAvailable(requiredEndDate);
			if (!isAvailable) {
				emitToasterMsg("error", "Missing Timestamp", "Please add a timestamp dated 2-Apr-26 and proceed with UK MRV Partial Report creation.");
				return;
			}
		}

		const isFullYear = selectedEventType === "full_year";
		const isPartialReportingPeriod2026 = selectedEventType === "partial_reporting_period_2026";
		const isPartialChangeOfCompany = selectedEventType === "partial_change_of_company";

		// UKETS PARTIAL (REPORTING PERIOD 2026) - FIXED START DATE (01-Jul-2026) TIMESTAMP VALIDATION
		if (isPartialReportingPeriod2026) {
			const ukEtsRequiredStartDate = "07-01-2026";
			const isAvailable = isDateAvailable(ukEtsRequiredStartDate);
			if (!isAvailable) {
				emitToasterMsg("error", "Missing Timestamp", "Please add a timestamp dated 1-Jul-26 and proceed with UK ETS Partial Report creation.");
				return;
			}
		}

		// VALIDATION
		if (isPartialChangeOfCompany) {
			setIsSubmit(true);
			let hasError = false;

			const isEndDateEmpty =
				!selectedEndDate ||
				(typeof selectedEndDate === "string" && selectedEndDate.includes("T18:30:00.000Z")) ||
				(selectedEndDate instanceof Date && selectedEndDate.toISOString().includes("T18:30:00.000Z"));

			if (isEndDateEmpty) {
				setEndDateError("Please select End Date");
				hasError = true;
			}

			const isStartDateEmpty =
				!selectedStartDate ||
				(typeof selectedStartDate === "string" && selectedStartDate.includes("T18:30:00.000Z")) ||
				(selectedStartDate instanceof Date && selectedStartDate.toISOString().includes("T18:30:00.000Z"));

			if (isStartDateEmpty) {
				setStartDateError("Please select Start Date");
				hasError = true;
			} else if (isUKETSMinStartDate && parseSelectedDate(selectedStartDate).isBefore(dayjs(UKETS_MIN_START_DATE), "day")) {
				// UKETS PARTIAL (CHANGE OF COMPANY) - RY2026: Start Date must not be before 01-Jul-2026
				setStartDateError("Start Date cannot be before 01-Jul-2026");
				hasError = true;
			}

			if (hasError) return;
		} else if (selectedEventType !== "full_year" && !isUKMRVPartial && !isPartialReportingPeriod2026) {
			setIsSubmit(true);
			let hasError = false;

			const isStartDateEmpty =
				!selectedStartDate ||
				(typeof selectedStartDate === "string" && selectedStartDate.includes("T18:30:00.000Z")) ||
				(selectedStartDate instanceof Date && selectedStartDate.toISOString().includes("T18:30:00.000Z"));

			const isEndDateEmpty =
				!selectedEndDate ||
				(typeof selectedEndDate === "string" && selectedEndDate.includes("T18:30:00.000Z")) ||
				(selectedEndDate instanceof Date && selectedEndDate.toISOString().includes("T18:30:00.000Z"));

			if (isStartDateEmpty) {
				setStartDateError("Please select Start Date");
				hasError = true;
			}
			if (isEndDateEmpty) {
				setEndDateError("Please select End Date");
				hasError = true;
			}

			if (hasError) return;
		}

		// BUILD START / END DATETIME STRINGS
		let start = "";
		let end = "";
		if (isFullYear) {
			start = `${startDateForFullYear} 00:00:00`;
			end = `${endDateForFullYear} 23:59:00`;
		} else if (isUKMRVPartial) {
			start = "01-01-2026 00:00:00";
			end = "04-02-2026 23:59:59";
		} else if (isPartialReportingPeriod2026) {
			start = "07-01-2026 00:00:00";
			end = "12-31-2026 23:59:59";
		} else if (isPartialChangeOfCompany) {
			start = `${dayjs(selectedStartDate).format("MM-DD-YYYY")} ${selectedStartTime}`;
			end = `${dayjs(selectedEndDate).format("MM-DD-YYYY")} ${selectedEndTime}`;
		} else {
			start = `${dayjs(selectedStartDate).format("MM-DD-YYYY")} ${selectedStartTime}`;
			end = `${dayjs(selectedEndDate).format("MM-DD-YYYY")} ${selectedEndTime}`;
		}

		// UKETS PARTIAL (CHANGE OF COMPANY) - RY2026: End Date must not be before the selected Start Date
		if (isUKETSMinStartDate && selectedStartDate && selectedEndDate) {
			const enteredStartDate = parseSelectedDate(selectedStartDate);
			const enteredEndDate = parseSelectedDate(selectedEndDate);

			if (enteredEndDate.isBefore(enteredStartDate, "day")) {
				setIsSubmit(true);
				setdateValidation(false);
				return;
			}
		}
		// Validate Start Date and Time should not be same as End Date and Time
		const startDateTime = dayjs(start, "MM-DD-YYYY HH:mm:ss");
		const endDateTime = dayjs(end, "MM-DD-YYYY HH:mm:ss");

		if (startDateTime.isValid() && endDateTime.isValid() && startDateTime.isSame(endDateTime)) {
			emitToasterMsg("error", "Invalid Date and Time", "Start date and time must not be the same as end date and time.");
			return;
		}

		// GATE SUBMISSION ON REQUIRED SELECTIONS
		const canProceed = isFullYear || isUKMRVPartial || isPartialReportingPeriod2026 || (!!selectedStartTime && !!selectedEndTime);

		if (!canProceed) return;
		const payloadData = {
			parentReportMstId: +reportDetails.ReportMstId,
			regulations: regulation,
			reportStartDate: start,
			reportEndDate: end,
			changeEvent: REPORT_SUBMISSION_DATA.CREATE_REPORT_TEXT,
			eventType: selectedEventType,
		};

		if (payloadData.reportStartDate > payloadData.reportEndDate) {
			setdateValidation(false);
			return;
		}
		openCreateReportModal();
		setLoading(true);
		try {
			var payloadDataArray = regulation.map((reg) => ({
					...payloadData,
					regulations: reg,
				}))

			await enqueueChildReportCreation(payloadDataArray);
			setLoading(false);
			getIsAnyMisStatementError();
			emitToasterMsg("success", "Report Submission", `${regulation} Report Created Successfully`);
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};


	return (
		<div className="row mt-3 p-1">
			<div className="col-md-12 mb-5 report-submission-table">
				<div className="d-flex justify-content-end pt-4 pb-4">
					<Button onClick={openCreateReportModal} startIcon={<Icon icon={ICONS.ADD} />}>
						Create Report
					</Button>
				</div>
				<MaterialReactTable table={reportSubmissionTable} />
				<Modal
					isOpen={confirmDelete}
					modalHeader
					padding={"70px"}
					headerHeight={"50px"}
					showFooter
					onCloseClickListener={() => {
						setConfirmDelete(false);
					}}
					footer={
						<div className="d-flex justify-content-end fixed-action-btns p-4">
							<Button
								className="modal-delete-btn"
								onClick={() => handleDelete()}
								primaryColor={COLORS.RED.DARK}
								primaryBackgroundColor={COLORS.RED.LIGHT}
							>
								{DELETE}
							</Button>
							<Button
								className="modal-cancel-btn ml-2"
								onClick={() => {
									setConfirmDelete(false);
								}}
							>
								{CANCEL}
							</Button>
						</div>
					}
				>
					<div>{DELETE_CONFIRMATION_TEXT_FOR_SINGLE_RECORD}</div>
				</Modal>
			</div>
			{openModal && (
				<AbsModal isOpen={openModal} title={`Create Report`} onClose={setOpenModal} close={openCreateReportModal}>
					<div className="p-4">
						<div className="regulation-warning-row">
						<div className="regulation-radio-container pb-3">
							{regulationOptions.map((option) => (
																								<div key={option.value} style={{ display: "flex" }}>
																									<AbsCheckBox
																										id={option.label}
																										label={option.label}
																										slim={true}
																										checked={regulation.includes(option.value)}
																										handleChange={(e) => {
																											if (e.target.checked) {
																												onChangeRegulation([...regulation, option.value]);
																											} else {
																												onChangeRegulation(regulation.filter((reg) => reg !== option.value));
																											}
																										 }}
							
																									/>
																			
																								</div>
																							))}
																							
						</div>
						{showPositionWarning && (
							<div className="position-warning" role="alert">
								<strong>Warning:</strong>
								<span>The position (Latitude and Longitude) at the start and/or end of the reporting period is to be reported.</span>
							</div>
						)}
						</div>
						{regulation.length === 0 && (
													<p className="error">At least one regulation type must be selected</p>
												)}
						{regulation.length > 0 && eventTypeOptions?.length > 0? (
							<div className="event-container">
								<Label name="Select Event Type" size="large" />
								{(selectedEventType) && (
									<AbsDropDown
										name="selectEvent"
										selected={selectedEventType ? selectedEventType : ""}
									handleChange={handleChangeEventType}
									options={eventTypeOptions ? eventTypeOptions : []}
								/>
							)}
						</div>): regulation.length > 0 && eventTypeOptions.length === 0 ?
						<span className="d-flex">No common event types available</span> : ""}

						{regulation.length > 0 && eventTypeOptions?.length > 0 ? selectedEventType === "full_year" ? (
							<div className="flx-gap">
								<div className="col-md-6 flx-gap">
									<Label size="large" name="Start Date :" />
									<span>{dayjs(startDateForFullYear).format("DD-MMMM-YYYY HH:mm:ss")}</span>
								</div>
								<div className="col-md-6 d-flex justify-content-left">
									<Label size="large" name="End Date :" />
									<span className="pl-3">{dayjs(endDateForFullYear).format("DD-MMMM-YYYY 23:59:00")}</span>
								</div>
							</div>
						) : selectedEventType === "partial_from_1_jan_2026_to_2_apr_2026" ? null : selectedEventType === "partial_reporting_period_2026" ? (
							<div className="flx-gap">
								<div className="col-md-6 flx-gap">
									<Label size="large" name="Start Date :" />
									<span>01-July-2026 00:00:00</span>
								</div>
								<div className="col-md-6 d-flex justify-content-left">
									<Label size="large" name="End Date :" />
									<span className="pl-3">31-December-2026 23:59:59</span>
								</div>
							</div>
						) : (
							allowedDateAndTime && (
								<>
									<div className="d-flex justify-content-left pb-4 dt-pcker-cntr">
										<div className="col-md-9 pl-0">
											<Label size="large" name="Start Date" />
											<Select
												placeholder="Select"
												className="w-100"
												fullWidth
												onChange={(event) => handleChangeDate(event.target.value, "startDate")}
												defaultValue={defaultFirstEnableDate?.length > 0 ? defaultFirstEnableDate[0].dateStamp : ""}
											>
												{startDateOptions?.length > 0 ? (
													startDateOptions.map((item, idx) => (
														<MenuItem key={idx} value={item.dateStamp}>
															{dayjs(item.dateStamp).format("MM/DD/YYYY")}
														</MenuItem>
													))
												) : (
													<MenuItem value="No data found" className="ml-2">
														No data found
													</MenuItem>
												)}
											</Select>
											{isSubmit && startDateError && <div className="err-msg">{startDateError}</div>}
										</div>
										<div className="col-md-3 pr-0">
											{selectedStartDate && startDateTimeSlots && showStartTimesslot && (
												<>
													<Label name="Start Time" size="large" />
													<Select
														placeholder="Select"
														className="w-100"
														fullWidth
														value={selectedStartTime || ""}
														onChange={(event) => handleChangeTime(event, "startTime")}
													>
														{selectedStartDate && startDateTimeSlots ? (
															startDateTimeSlots.map((time, idx) => (
																<MenuItem key={idx} value={time}>
																	{time}
																</MenuItem>
															))
														) : (
															<MenuItem value="No data found" className="ml-2">
																No data found
															</MenuItem>
														)}
													</Select>

													{isSubmit &&
														selectedEventType &&
														selectedEventType !== "full_year" &&
														startDateTimeSlots &&
														!selectedStartTime && <div className="err-msg">Please select Start Time</div>}
												</>
											)}
										</div>
									</div>
									<div className="d-flex justify-content-left pb-4 dt-pcker-cntr">
										<div className="col-md-9 pl-0">
											<Label size="large" name="End Date" />
											<Select
												placeholder="Select"
												className="w-100"
												fullWidth
												defaultValue={defaultFirstEnableDate?.length > 0 ? defaultFirstEnableDate[0].dateStamp : ""}
												onChange={(event) => handleChangeDate(event.target.value, "endDate")}
											>
												{endDateOptions?.length > 0 ? (
													endDateOptions.map((item, idx) => (
														<MenuItem key={idx} value={item.dateStamp}>
															{dayjs(item.dateStamp).format("MM/DD/YYYY")}
														</MenuItem>
													))
												) : (
													<MenuItem value="No data found" className="ml-2">
														No data found
													</MenuItem>
												)}
											</Select>
											{isSubmit && endDateError && <div className="err-msg">{endDateError}</div>}
											{isSubmit && !dateValidation && (
												<div className="err-msg">The end date should not be earlier than the start date.</div>
											)}
										</div>
										<div className="col-md-3 pr-0">
											{selectedEndDate && endDateTimeSlots && showEndTimesslot && (
												<>
													<Label name="EndTime" size="large" />
													<Select
														placeholder="Select"
														className="w-100"
														fullWidth
														value={selectedEndTime || ""} 
														onChange={(event) => handleChangeTime(event, "endTime")}
													>
														{selectedEndDate && endDateTimeSlots ? (
															endDateTimeSlots.map((time, idx) => (
																<MenuItem key={idx} value={time}>
																	{time}
																</MenuItem>
															))
														) : (
															<MenuItem value="No data found" className="ml-2">
																No data found
															</MenuItem>
														)}
													</Select>

													{isSubmit &&
														selectedEventType &&
														selectedEventType !== "full_year" &&
														endDateTimeSlots &&
														!selectedEndTime && <div className="err-msg">Please select End Time</div>}
												</>
											)}
										</div>
									</div>
								</>
							)
						):""}
						{regulation.includes("UKETS") && selectedEventType==="full_year" && (
									<div className="d-flex justify-content-left pt-3">
										<span className="ukets-note">Note : For UK ETS, the start date is fixed to 01-July-2026 and the end date is fixed to 31-December-2026 for Full Year report in 2026</span>
									</div>
								)}
						<div className="d-flex justify-content-end pt-4 pb-4">
							<Button onClick={submitCreateChildReport} disabled={regulation.length === 0 || !selectedEventType}>
								Create
							</Button>
						</div>
					</div>
				</AbsModal>
			)}
		</div>
	);
};

export default ReportSubmission;